import { getCycleDate } from "../Authorization";

function Footer(props) {
  const cycleDate = getCycleDate();
  let arincText = '';
  if (cycleDate) {
    arincText = 'AIRAC@' + cycleDate + ',';
  }
  return (
    <footer id="footer" className="footer">{arincText} ©WEATHERNEWS INC. ALL RIGHTS RESERVED.</footer>
  );
}
export default Footer;